import { Suspense } from 'react';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import Loading from '../components/loading';
import { appRoutes } from './app-routes';
import RequireAuth from './require-auth';

const router = createBrowserRouter(appRoutes);

const Routes = () => {
  return (
    <RequireAuth>
      <Suspense fallback={<Loading />}>
        <RouterProvider router={router} />
      </Suspense>
    </RequireAuth>
  );
};

export default Routes;
